// extracted by mini-css-extract-plugin
export var columnList = "_hg-0";